import {throwIfUndefined} from '@coolcolduk/util';
import {FirestoreTimestamp, mapTodoDbToType, mapTodoWriteToDb, TodoWrite, type Todo} from '@cp/model';
import {addDoc, getDoc, serverTimestamp} from 'firebase/firestore';
import {getTodoCollection} from './getTodoCollection';

export default async function createTodoDoc(uid: string, input: TodoWrite): Promise<Todo> {
  const data = mapTodoWriteToDb(input, serverTimestamp() as unknown as FirestoreTimestamp);
  const ref = await addDoc(getTodoCollection(uid), data);
  return throwIfUndefined(mapTodoDbToType(await getDoc(ref)));
}
